module.exports = __webpack_public_path__ + "img/speech_nodata.e2723b1a.svg";